import Axios from 'axios';
import { Projects } from 'constantes/global';
import secureStorage from 'hooks/secureStorage';
import { COMMON_URL_PAMOFOR, COMMON_URL_PRESFOR } from './api';

// Récupération des tokens de projet
const project_tokens = (() => {
  const storedTokens = secureStorage.getItem('project_tokens');
  if (!storedTokens) return [];

  try {
    // Parse les tokens stockés
    const parsedTokens = storedTokens;
    if (!Array.isArray(parsedTokens)) {
      console.error('Stored tokens is not an array');
      return [];
    }

    // Get tokens for each project
    const projectTokens = {};

    // Create a map of project names to avoid repeated find operations
    const tokenMap = new Map(
      parsedTokens.map(token => [token.projectName, token])
    );

    // Define known projects and their tokens
    Projects.forEach(projectName => {
      const projectData = tokenMap.get(projectName);
      projectTokens[projectName] = {
        accessToken: projectData?.accessToken || '',
        refreshToken: projectData?.refreshToken || ''
      };
    });

    // Return array format for compatibility with existing code
    return parsedTokens.map((token) => ({
      ...token,
    }));
  } catch (error) {
    console.error('Error parsing project tokens:', error);
    return [];
  }
})();

// Fonction pour obtenir le token d'accès du projet actif
const getActiveProjectToken = () => {
  const activeProject = secureStorage.getItem('active_project');
  if (activeProject) {
    const project = project_tokens.find((p) => p.projectName === activeProject);
    return project?.accessToken || '';
  }
  return '';
};

const defaultAxios = Axios.create({
  headers: {
    'Content-Type': 'application/json',
    Authorization: '',
  },
});

defaultAxios.interceptors.request.use(
  async (config) => {
    // Priorité au token utilisateur s'il existe
    if (secureStorage.getItem('usertoken_session') && secureStorage.getItem('project_tokens').length === 1) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${secureStorage.getItem('usertoken_session')}`,
      };
    }
    // Sinon utiliser le token du projet en fonction de l'URL appelée
    else {
      // Récupérer tous les tokens de projet
      const storedTokens = secureStorage.getItem('project_tokens');
      const parsedTokens = storedTokens ? storedTokens : [];

      // Déterminer quel token utiliser en fonction de l'URL
      if (config.url.includes(COMMON_URL_PAMOFOR) || config.url.startsWith('pamofor')) {
        // Utiliser le token PAMOFOR
        const pamoforProject = parsedTokens.find(p => p.projectName === Projects[1].label);
        if (pamoforProject?.accessToken) {
          config.headers = {
            ...config.headers,
            // Authorization: `Bearer ${secureStorage.getItem('usertoken_session')}`,
            Authorization: `Bearer ${pamoforProject.accessToken}`,

          };
        }
      } else if (config.url.includes(COMMON_URL_PRESFOR) || config.url.startsWith('presfor')) {
        // Utiliser le token PRESFOR
        const presforProject = parsedTokens.find(p => p.projectName === Projects[2].label);
        if (presforProject?.accessToken) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${presforProject.accessToken}`,
          };
        }
      } else {
        // Utiliser le token du projet actif pour les autres URLs
        const projectToken = getActiveProjectToken();
        if (projectToken) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${projectToken}`,
          };
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

defaultAxios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    // Check for a 401 status code
    if (err.response && err.response.status === 401) {
      secureStorage.removeItem('isAuthenticated');
      secureStorage.removeItem('usertoken_session');
      window.location.href = '/psfcseconnecter';
    }

    return Promise.reject(err);
  }
);

export function apiClient(method, url, options = {}) {
  const { data = {}, headers = {}, params = {}, ...rest } = options;
  return defaultAxios({
    url,
    data,
    method,
    params,
    headers,
    ...rest,
  });
}


export const apis = {
  get: (url, args) => apiClient('get', url, args),
  post: (url, args) => apiClient('post', url, args),
  put: (url, args) => apiClient('put', url, args),
  patch: (url, args) => apiClient('patch', url, args),
  delete: (url, args) => apiClient('delete', url, args),
};
